export function tree (data, component) {
  if (data && data.length !== 0) {
    for (let i = 0; i < data.length; i++) {
      let item = data[i]
      if (item.component === component) {
        return item.name
      } else {
        if (item.children && item.children.length > 0) {
          let list = tree(item.children, component)
          if (list) return list
        }
      }
    }
  } else {
    let datas = JSON.parse(localStorage.getItem('USER_ROUTER'))[0].children
    for (let i = 0; i < datas.length; i++) {
      let item = datas[i]
      if (item.component === component) {
        return item.name
      } else {
        if (item.children && item.children.length > 0) {
          let list = tree(item.children, component)
          if (list) return list
        }
      }
    }
  }
  return ''
}

// 将从localStorage读取数据的逻辑封装成函数，并增加异常处理
// export function getUserRouterFromLocalStorage () {
//   try {
//     const item = localStorage.getItem('USER_ROUTER')
//     if (item) {
//       return JSON.parse(item)[0].children
//     }
//     // 如果没有找到数据，可以返回空数组或进行其他处理
//     return []
//   } catch (e) {
//     console.error('Error parsing USER_ROUTER from localStorage:', e)
//     // 根据实际情况处理异常，这里返回空数组作为示例
//     return []
//   }
// }

// // 优化后的tree函数
// export function tree (data = [], component) {
//   // 将从localStorage读取数据的操作移到函数外部，避免重复操作
//   const localData = getUserRouterFromLocalStorage()
//   // 使用循环代替递归来避免栈溢出，同时减少重复代码
//   if (data.length !== 0) {
//     var stack = localData
//   } else {
//     stack = data
//   }
//   while (stack.length > 0) {
//     const item = stack.pop()
//     if (item.component === component) {
//       return item.name
//     }
//     if (item.children && item.children.length > 0) {
//       stack.push(...item.children)
//     }
//   }
//   // 如果没有找到匹配项，可以返回null或进行其他处理
//   return ''
// }



// WEBPACK FOOTER //
// ./src/utils/getMuneList.js